const getDefaultState = () => {
  return {
    articles: [
      {
        title:
          "How to use our ready-to-use templates in Drag and Drop Builder?",
        link: "https://help.mailercloud.com/how-to-use-our-ready-to-use-templates-in-drag-and-drop-builder",
      },
      {
        title: "How to get started with Drag and Drop Builder?",
        link: "https://help.mailercloud.com/how-to-get-started-with-drag-drop-builder",
      },
      {
        title: "How to create email templates with Drag and Drop Builder?",
        link: "https://help.mailercloud.com/how-to-create-email-templates-with-drag-drop-builder",
      },
      {
        title: "What is the responsive email template gallery in Mailercloud?",
        link: "https://help.mailercloud.com/responsive-email-template-gallery-in-mailercloud",
      },
      {
        title: "How to create a regular campaign in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-create-a-regular-campaign-in-mailercloud",
      },
      {
        title: "What are the campaign tags in Mailercloud?",
        link: "https://help.mailercloud.com/what-is-campaign-tags-in-mailercloud",
      },
      {
        title: "How to schedule, pause and filter a campaign in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-schedule-pause-and-filter-a-campaign-in-mailercloud",
      },
      {
        title: "How to create a time-based campaign in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-create-a-time-based-campaign-in-mailercloud",
      },

      {
        title:
          "How to ensure safe email delivery by Mailercloud blacklist monitoring tool?",
        link: "https://help.mailercloud.com/how-to-ensure-safe-email-delivery-by-mailercloud-blacklist-monitoring-tool",
      },
      {
        title: "How to personalize your emails using Mailercloud?",
        link: "https://help.mailercloud.com/how-to-personalise-your-emails-using-mailercloud",
      },
      {
        title: "How to deliver emails by timezone using Mailercloud?",
        link: "https://help.mailercloud.com/how-to-deliver-emails-by-timezone-using-mailercloud",
      },
      {
        title: "How to deliver emails by timezone using Mailercloud?",
        link: "https://help.mailercloud.com/how-to-deliver-emails-by-timezone-using-mailercloud",
      },
      {
        title: "How to set multi-user permissions on Mailercloud?",
        link: "https://help.mailercloud.com/how-to-set-multi-user-permissions-on-mailercloud",
      },
      {
        title: "What are the advanced reports in Mailercloud?",
        link: "https://help.mailercloud.com/what-is-advanced-reports-in-mailercloud",
      },
      {
        title: "What is the timestamp in Mailercloud?",
        link: "https://help.mailercloud.com/what-is-time-stamp-in-mailercloud",
      },
      {
        title:
          "What are the sections, structures, and containers in Drag and Drop Builder?",
        link: "https://help.mailercloud.com/what-are-the-section-structures-and-containers-in-drag-and-drop-builder",
      },
      {
        title:
          "What are the blocks and how to use them in Drag and Drop Builder?",
        link: "https://help.mailercloud.com/what-are-the-blocks-and-how-to-use-them-in-drag-and-drop-builder",
      },
      {
        title:
          "How to add images, tables, and personalization tags in Drag and Drop Builder?",
        link: "https://help.mailercloud.com/how-to-add-image-tables-and-personalization-tag-in-drag-and-drop-builder",
      },
      {
        title:
          "How to preview, export, and save email templates in Drag and Drop Builder?",
        link: "https://help.mailercloud.com/how-to-preview-export-and-save-email-templates-in-drag-and-drop-builder",
      },
      {
        title:
          "How to create templates using Mailercloud's custom HTML editor?",
        link: "https://help.mailercloud.com/how-to-create-templates-using-mailercloud-custom-html-editor",
      },
      {
        title:
          "How to create webforms and integrate them with your WordPress site?",
        link: "https://help.mailercloud.com/how-to-create-webforms-and-integrate-them-with-your-wordpress-site",
      },
      {
        title:
          "How to create webforms and integrate them with your WordPress site?",
        link: "https://help.mailercloud.com/how-to-create-webforms-and-integrate-them-with-your-wordpress-site",
      },
      {
        title: "How to synchronize your Mailercloud contacts with WordPress?",
        link: "https://help.mailercloud.com/how-to-synchronize-your-mailercloud-contacts-with-wordpress",
      },
      {
        title: "What are the plans and pricing at Mailercloud?",
        link: "https://help.mailercloud.com/what-are-the-plans-and-pricing-at-mailercloud",
      },
      {
        title:
          "What are the key terminologies under Mailercloud's Plan and Pricing?",
        link: "https://help.mailercloud.com/what-are-the-key-terminologies-under-mailerclouds-plan-and-pricing",
      },
      {
        title: "How to switch between different plans?",
        link: "https://help.mailercloud.com/how-to-switch-between-different-plans",
      },
      {
        title: "How to get started with the template gallery?",
        link: "https://help.mailercloud.com/how-to-get-started-with-the-template-gallery",
      },
      {
        title:
          'How to create a template using “layout”, "theme" and “code your own”?',
        link: "https://help.mailercloud.com/how-to-create-a-template-using-layout-theme-and-code-your-own",
      },
      {
        title: "How to integrate Mailercloud with an app using Zapier?",
        link: "https://help.mailercloud.com/how-to-integrate-mailercloud-with-an-app-using-zapier",
      },
      {
        title: "What are the key terminologies in Zapier?",
        link: "https://help.mailercloud.com/what-are-the-key-terminologies-in-zapier",
      },
      {
        title: "How to install Mailercloud’s WordPress Plugin?",
        link: "https://help.mailercloud.com/how-to-install-mailerclouds-wordpress-plugin",
      },
      {
        title: "What is the sender domain authentication in Mailercloud?",
        link: "https://help.mailercloud.com/sender-domain-authentication-in-mailercloud",
      },
      {
        title: "WordPress Integration FAQs",
        link: "https://help.mailercloud.com/important-faqs",
      },
      {
        title: "Zapier Integration FAQs",
        link: "https://help.mailercloud.com/frequently-asked-questions-faqs",
      },
      {
        title: "Plan and Pricing FAQs",
        link: "https://help.mailercloud.com/common-faqs",
      },
      {
        title: "Template Gallery FAQs",
        link: "https://help.mailercloud.com/important-faqs-1",
      },
      {
        title: "Drag and Drop Builder FAQs",
        link: "https://help.mailercloud.com/common-faq-for-drag-and-drop-builder",
      },
      {
        title: "How to change an Enterprise plan to Premium",
        link: "https://help.mailercloud.com/how-to-change-an-enterprise-plan-to-premium",
      },
      {
        title: "How does the Mailercloud dashboard look like?",
        link: "https://help.mailercloud.com/an-introduction-to-the-mailercloud-dashboard",
      },
      {
        title: "How to create a Mailercloud account?",
        link: "https://help.mailercloud.com/how-to-create-mailercloud-account",
      },
      {
        title: "How to create contact list segmentation in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-create-contact-list-segmentation-in-mailercloud",
      },
      {
        title: "How to add new contacts in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-add-new-contacts-in-mailercloud",
      },
      {
        title: "How to create webforms in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-create-webforms-in-mailercloud",
      },
      {
        title: "How to set email automation in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-set-email-automation-in-mailercloud",
      },
      {
        title: "How to create autoresponders in Mailercloud?",
        link: "https://help.mailercloud.com/how-to-create-autoresponders-in-mailercloud",
      },
      {
        title: "How to set A/B test campaigns in Mailercloud?",
        link: "https://help.mailercloud.com/a-complete-guide-on-mailercloud-a/b-testing",
      },
      {
        title: "What is the contact rating in Mailercloud?",
        link: "https://help.mailercloud.com/what-is-contact-rating-in-mailercloud",
      },
    ],
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getArticles: (state) => {
    return state.articles;
  },
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
